import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import useUsasClubFacilityLinksData from '../../../state/clubFacilityLinks/UseUsasClubFacilityLinksData';

import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';
import useClubRegistrationNewData from '../../../state/clubRegistrationNew/UseClubRegistrationNewData';
import useClubRegistrationNavData from '../../../state/clubRegistration/leftNavigation/UseClubRegistrationNavData';

const useClubRegistrationFacilityPoolDetail = () => {
  const navigate = useNavigate();
  const { usasClubFacilityLinksState } = useUsasClubFacilityLinksData();
  const { facilityState } = useFacilityData();
  const { clubRegistrationState } = useClubRegistrationNewData();
  const { clubRegistrationNavState } = useClubRegistrationNavData();

  useEffect(() => {
    if (clubRegistrationState.isObjLoaded === false) {
      navigate(NavLinks.CLUB_REGISTRATION_ENTRY_NEW);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    usasClubFacilityLinksState,
    clubRegistrationState,
    clubRegistrationNavState,
    facilityState
  };
};

export default useClubRegistrationFacilityPoolDetail;